import { authFetch } from "../auth-context";
import { validClaudeArchive } from "./claudeTimeline";
import type { ClaudeArchive } from "./types";

type Waiter = {requestMessageId:string;resolve:(runs:ClaudeArchive[])=>void;reject:()=>void};
const pending = new Map<string,Waiter[]>();

/** Optional, coalesced discovery for visible turns, including Pause with no final. */
export function requestClaudeArchives(companyId:string, requestMessageId:string):Promise<ClaudeArchive[]> {
  return new Promise((resolve,reject) => {
    const waiting = pending.get(companyId);
    if (waiting) waiting.push({requestMessageId,resolve,reject});
    else {
      pending.set(companyId,[{requestMessageId,resolve,reject}]);
      setTimeout(() => void flush(companyId),0);
    }
  });
}

async function flush(companyId:string) {
  const waiting = pending.get(companyId) ?? [];
  pending.delete(companyId);
  const ids = [...new Set(waiting.map(item => item.requestMessageId))];
  for (let offset=0; offset<ids.length; offset+=50) {
    const batchIds = ids.slice(offset,offset+50);
    const group = waiting.filter(item => batchIds.includes(item.requestMessageId));
    try {
      const query = new URLSearchParams({requestMessageIds:JSON.stringify(batchIds)});
      const response = await authFetch("/api/sessions/"+encodeURIComponent(companyId)+"/claude-runs?"+query);
      if (!response.ok) throw new Error("Public history unavailable");
      const page = await response.json();
      if (page.schemaVersion !== 1 || !Array.isArray(page.runs) || page.runs.length > 50 || page.cursor !== null)
        throw new Error("Invalid public history index");
      const runs:ClaudeArchive[] = [];
      for (const item of page.runs) {
        const run = validClaudeArchive(item);
        if (run && batchIds.includes(run.requestMessageId) && !runs.some(existing => existing.runId === run.runId)) runs.push(run);
      }
      for (const waiter of group) waiter.resolve(runs.filter(run => run.requestMessageId === waiter.requestMessageId));
    } catch {
      for (const waiter of group) waiter.reject();
    }
  }
}
